import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import { withRouter } from "react-router";
import { Result, Button } from 'antd';

const NotAuthPage = (props) => {
	return(
		<PageTemplate>
			<Result
				status="403"
				title="권한이 없습니다."
				extra={
					<Button 
						type="primary" 
						key="console"
						onClick={()=>props.history.push('/')}
					>
						메인페이지
					</Button>
				}
			/>
		</PageTemplate>
	);
};

export default withRouter(NotAuthPage);